import { useTranslation } from 'react-i18next';
import { BoundedContent, Box, Column, GridContainer, P, Row } from '@vp/swan';
import EditWrapper from '../EditWrapper/EditWrapper';

interface ErrorMessageProps {
    title?: string;
    message?: string;
}

const ErrorMessage = ({ title, message }: ErrorMessageProps) => {
    const { t } = useTranslation();
    const defaultTitle = t('Vista Logos > Error Message > Title.value');
    const defaultMessage = t('Vista Logos > Error Message > Message.value');

    return (
        <BoundedContent
            marginTop={{ xs: '6', sm: '6', md: '7', lg: '7', xl: '7' }}
            marginBottom="7"
        >
            <GridContainer>
                <Row>
                    <Column span={12} textAlign="center">
                        <Box>
                            <EditWrapper url={t('Vista Logos > Error Message > Image.editUrl')}>
                                <img
                                    src={t('Vista Logos > Error Message > Image.src')}
                                    alt={t('Vista Logos > Error Message > Image.altText')}
                                />
                            </EditWrapper>
                        </Box>
                        <P fontSkin="title-display">{title || defaultTitle}</P>
                        <P>{message || defaultMessage}</P>
                    </Column>
                </Row>
            </GridContainer>
        </BoundedContent>
    );
};

export default ErrorMessage;
